import { Text } from '@cubeyou-team/hx-react-components';
import React from 'react';
import styled from 'styled-components';

const StyledDraftBadge = styled.div`
  padding: 0 0.25rem;
  margin-right: -1rem;
  border-radius: 0.25rem;
  background-color: ${props => props.theme.colors.light_darker_1};
`;

export const DraftBadge = () => {
  return (
    <StyledDraftBadge>
      <Text size="xsmall" variant="dark">
        DRAFT
      </Text>
    </StyledDraftBadge>
  );
};
